module.exports = __webpack_public_path__ + "static/icons-8f1c676a52b18e1676667bdb19826d15.svg";